import StickySidebar from 'sticky-sidebar';

export function stickySidebarFunc() {
  const sidebar = document.querySelectorAll('.js-stickySidebar-container');

  let ww = window.innerWidth;

  if(sidebar.length) {
    for (let i = 0; i < sidebar.length; i++) {
      const el = sidebar[i];
      const bar = el.querySelector('.js-stickySidebar');
      let spacingTop = 0;
      let spacingBottom = 0;
      let isInit = false;
      let stickySidebar = null;
      
      if(el.getAttribute('data-sticky-top')) spacingTop = el.getAttribute('data-sticky-top');
      if(el.getAttribute('data-sticky-bottom')) spacingBottom = el.getAttribute('data-sticky-bottom');

      const init = () => {
        ww = window.innerWidth;
        if(ww >= 1024) {
          if(bar) bar.removeAttribute('style');
          if(!isInit) {
            stickySidebar = new StickySidebar(el, {
              topSpacing: spacingTop,
              bottomSpacing: spacingBottom,
              containerSelector: '.js-stickySidebar-container',
              innerWrapperSelector: '.js-stickySidebar'
            });
            isInit = true;
          } else {
            stickySidebar.updateSticky();
          }
        } else {
          if(bar) bar.removeAttribute('style');
          if(stickySidebar) stickySidebar.destroy();
          stickySidebar = null;
          isInit = false;
        }
      }

      setInterval(init, 1000)
      window.addEventListener('resize', init);
      window.addEventListener('orientationchange', init);
      init();
    }
  }
}